import { breakpoints } from 'config/config';
import styled from 'styled-components';

export const StyledDeliveryConditionsForm = styled.div`
  .form-section {
    border: 1px solid ${(props) => props.theme.colorBorder};
    border-radius: 5px;
    padding: 20px;
    background-color: ${(props) => props.theme.filterBackground};

    h3 {
      margin-bottom: 24px;
      font-size: 16px;
      font-weight: 600;
      color: ${(props) => props.theme.textColor};
    }
  }

  .form-row {
    display: flex;
    gap: 24px;
    align-items: flex-start;

    &.single-field {
      .form-field {
        flex: 1;
      }
    }

    &.checkbox-row {
      align-items: center;
      gap: 32px;
    }
  }

  .form-field {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 8px;

    &.checkbox-field {
      flex: none;
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 8px;
    }

    .ant-input,
    .ant-input-number,
    .ant-picker,
    .ant-select,
    .ant-textarea {
      width: 100%;
    }
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    .form-section {
      .title {
        font-size: 1rem !important;
      }
    }
  }
`;

export const StyledDetailedDeliveryForm = styled.div`
  .deliveries-items {
    .cards-container {
      display: flex;
      flex-direction: column;
      gap: 12px;
      margin-top: 20px;

      .add-delivery-card {
        background: ${(props) => props.theme.filterBackground};
      }
    }
  }

  .form {
    background: ${(props) => props.theme.filterBackground};
    border: 1px solid ${(props) => props.theme.border};
    border-radius: 8px;
    padding: 20px;

    .ant-form {
      font-size: 14px;
    }

    .required-quantity,
    .min-quantity {
      flex: 1;
    }

    .ant-picker,
    .ant-input-number {
      width: 100%;
    }

    .checkbox-field {
      margin-bottom: 20px;
    }

    .ant-form-item {
      margin-bottom: 10px;
    }

    .form-row {
      display: flex;
      gap: 24px;
    }

    .form-field {
      width: 100%;
    }

    .address-finder {
      margin-bottom: 0;

      @media (max-width: ${breakpoints.lg}px) {
        .form-control {
          min-height: 32px;
        }
      }
    }

    .admin {
      justify-content: space-between;
    }

    .allow-smaller-quantity {
      .ant-form-item {
        margin: 0;
      }
    }

    .form-field.checkbox-field {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 8px;
    }

    .quality-marks {
      padding-top: 20px;
      width: 100%;

      .ant-checkbox-group {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 15px;
      }
    }

    .form-actions {
      border-top: 1px solid ${(props) => props.theme.colorBorder};
      padding-top: 20px;
      display: flex;
      justify-content: flex-end;
      gap: 10px;
    }

    .selected-products {
      display: flex;
      flex-direction: column;
      margin: 0 0 20px 0;
      background-color: ${(props) => props.theme.white};
      border-radius: 5px;
    }

    .product-quantity-row {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 0 12px;
      padding: 12px 0;
      border-radius: 4px;

      &:not(:last-child) {
        border-bottom: 1px solid ${(props) => props.theme.borderBottom};
      }

      .product-info {
        display: flex;
        flex-direction: column;
        gap: 4px;

        .product-name {
          font-weight: 600;
          color: ${(props) => props.theme.textColor};
        }

        .product-unit {
          font-size: 12px;
          color: ${(props) => props.theme.grey};
        }
      }

      .quantity-input {
        display: flex;
        align-items: center;
        justify-content: end;
        gap: 10px;

        .ant-form-item {
          margin: 0;
        }

        .ant-input {
          width: 320px;
        }
      }

      @media (max-width: ${breakpoints.lg}px) {
        flex-direction: column;
        align-items: flex-start;

        .quantity-input {
          width: 100%;
          flex-direction: column;
          align-items: flex-start;

          .ant-form-item {
            width: 100%;
          }

          .ant-input {
            width: 100%;
          }
        }
      }
    }

    .form-row {
      @media (max-width: ${breakpoints.lg}px) {
        flex-direction: column;
        gap: 0;
      }
    }

    @media (max-width: ${breakpoints.lg}px) {
      padding: 12px;
    }
  }

  .quantity-and-unit {
    width: 100%;
    display: flex;

    .quantity-input {
      flex: 1;
      border-right: none;

      .ant-input-number {
        border-right: 1px solid transparent;
      }

      .ant-input-number:hover {
        border-right: 1px solid ${(props) => props.theme.black};
      }

      .ant-input-number:focus-within {
        border-right: 1px solid ${(props) => props.theme.black};
      }
    }

    .ant-select {
      height: 100%;
      min-width: 200px;
      margin-top: 32px;

      @media (max-width: ${breakpoints.lg}px) {
        min-width: 150px;
        margin-top: 28px;
      }

      .ant-select-selector {
        background: ${(props) => props.theme.inputAddonBg};
      }
    }
  }

  &.form-overlay {
    position: relative;

    &::before {
      content: '';
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: ${(props) => props.theme.halfBlack};
      z-index: 1000;
    }

    .form {
      position: relative;
      z-index: 1001;
    }
  }
`;

export const StyledFreeFormDeliveryForm = styled.div`
  .form-section {
    .form-row {
      display: flex;
      gap: 24px;
      align-items: flex-start;
    }

    .form-field {
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 8px;

      .ant-picker {
        width: 100%;
      }
    }

    .free-form-description {
      min-height: 200px;
    }
  }
`;
